import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (match) {
      const sessionId = match[1];
      (async () => {
        try {
          const res = await api.post("/auth/session", { session_id: sessionId });
          setUser(res.data);
          const cleanPath = window.location.pathname || "/admin/dashboard";
          window.history.replaceState(null, "", cleanPath);
        } catch (e) {
          const msg = e?.response?.data?.detail || "Authentication failed";
          window.history.replaceState(null, "", "/admin?error=" + encodeURIComponent(msg));
        } finally {
          setLoading(false);
        }
      })();
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
